import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import type { IInfraSettings } from "@/features/servers/schemas/servers";
import {
  getInfraSettings,
  saveInfraSettings,
  type SaveInfraSettingsInput,
} from "@/features/servers/services/infraSettingsService";

export const infraSettingsKeys = {
  all: ["infraSettings"] as const,
  detail: () => [...infraSettingsKeys.all, "global"] as const,
};

export function useInfraSettings() {
  return useQuery<IInfraSettings>({
    queryKey: infraSettingsKeys.detail(),
    queryFn: getInfraSettings,
    staleTime: 5 * 60 * 1000,
  });
}

export function useSaveInfraSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: SaveInfraSettingsInput | number) =>
      saveInfraSettings(input),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: infraSettingsKeys.all });
      // Inventario depende de versiones objetivo / política SO
      await queryClient.invalidateQueries({ queryKey: ["centerInfra", "inventory"] });
      await queryClient.invalidateQueries({
        queryKey: ["centerInfra", "hostVerification"],
      });
    },
  });
}
